import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { setupNavigation } from "../../../redux/actions/navItemsActions";
import PropTypes from "prop-types";
import Spinner from "../../common/Spinner";
import UserAvatar from 'react-user-avatar';
import * as apiConfig from "../../../api/config";
import ProfileTimeline from "./ProfileTimeline";
import ProfileNetwork from "./ProfileNetwork";
import GroupSearch from "../../groups/GroupSearch";
import EventSearch from "../../events/EventSearch";
import PostFeedControl from "../../postComments/PostFeedControl";
import "./ProfilePage.css";

function ProfilePage(
    {
        setupNavigation,
        user,
        timeline,
        loadUserTimelineFeed,
        history
    }
) {

    const [activeForm, setActiveForm] = useState({ form: "timeline" });
    const [processing, setProcessing] = useState(true);

    const navigationItems =
    {
        sections: [{
            name: '',
            items: [
                {
                    path: '/user/profile',
                    text: 'Timeline',
                    icon: 'fas fa-clock'
                },
                {
                    path: '/user/routes',
                    text: 'My Routes',
                    icon: 'fas fa-route'
                },
                {
                    path: '/user/bookmarks',
                    text: 'Bookmarked Routes',
                    icon: 'fas fa-star'
                }
            ]
        },
        {
            name: 'Settings',
            items: [
                {
                    path: '/user/settings/general',
                    text: 'Settings',
                    icon: 'fas fa-cog'
                }
            ]
        }]
    };

    useEffect(() => {
        document.title = "Me@JustGoRide | JustGoRide";
        setupNavigation(navigationItems);

    }, []);


    function setForm(e) {
        e.preventDefault(); 
        var form = e.target.title;
        setActiveForm(setActiveForm => ({
            ...setActiveForm,
            form: form
        }));
    }

    return (
        <div>
            <div className="profile-banner">
                
                <div className="profile-banner-info">
                    <h2 className="profile-banner-title">{`${user.firstName} ${user.surname}`}</h2>
                </div>
                <div className="profile-banner-bg-img-gradient"></div>
                {user.bannerAvailable &&
                    <img className="profile-banner-bg-img" src={`${apiConfig.API_URL}user/banner/${user.id}.png?v=${user.bannerVersion}`} />
                }
                <div className="profile-avatar-container">
                    {user.avatarAvailable ?
                        <React.Fragment>
                            <UserAvatar className="profile-banner-avatar d-block d-sm-none" size="100" name={`${user.firstName} ${user.surname}`} src={`${apiConfig.API_URL}user/avatar/${user.id}.png?v=${user.avatarVersion}`} />
                            <UserAvatar className="profile-banner-avatar d-none d-sm-block" size="150" name={`${user.firstName} ${user.surname}`} src={`${apiConfig.API_URL}user/avatar/${user.id}.png?v=${user.avatarVersion}`} />
                        </React.Fragment>
                        :
                        <div className="profile-banner-avatar"><span className="fas fa-user"></span></div>
                    }
                </div>
            </div>
            <div className="profile-tab">
                <ul className="nav nav-tabs">
                    <li className="nav-item">
                        <a title="timeline" className={activeForm.form == "timeline" ? "nav-link d-sm-none active" : "nav-link d-sm-none"} href="#" onClick={setForm}><span title="timeline" className="fas fa-clock"></span></a>
                        <a title="timeline" className={activeForm.form == "timeline" ? "nav-link d-none d-sm-inline active" : "nav-link d-none d-sm-inline"} href="#" onClick={setForm}><span title="timeline" className="fas fa-clock mr-1"></span>Timeline</a>
                    </li>
                    <li className="nav-item">
                        <a title="network" className={activeForm.form == "network" ? "nav-link d-sm-none active" : "nav-link d-sm-none"} href="#" onClick={setForm}><span title="network" className="fas fa-user-friends"></span></a>
                        <a title="network" className={activeForm.form == "network" ? "nav-link d-none d-sm-inline active" : "nav-link d-none d-sm-inline"} href="#" onClick={setForm}><span title="network" className="fas fa-user-friends mr-1"></span>Network</a>
                    </li>
                    <li className="nav-item">
                        <a title="groups" className={activeForm.form == "groups" ? "nav-link d-sm-none active" : "nav-link d-sm-none"} href="#" onClick={setForm}><span title="groups" className="fas fa-users"></span></a>
                        <a title="groups" className={activeForm.form == "groups" ? "nav-link d-none d-sm-inline active" : "nav-link d-none d-sm-inline"} href="#" onClick={setForm}><span title="groups" className="fas fa-users mr-1"></span>Groups</a>
                    </li>
                    <li className="nav-item">
                        <a title="events" className={activeForm.form == "events" ? "nav-link d-sm-none active" : "nav-link d-sm-none"} href="#" onClick={setForm}><span title="events" className="far fa-calendar-alt"></span></a>
                        <a title="events" className={activeForm.form == "events" ? "nav-link d-none d-sm-inline active" : "nav-link d-none d-sm-inline"} href="#" onClick={setForm}><span title="events" className="far fa-calendar-alt mr-1"></span>Events</a>
                    </li>
                </ul>
            </div>
            <div>
                {
                    (() => {
                        switch (activeForm.form) {
                            case "timeline":
                                return (
                                    <PostFeedControl mode={"User"} />
                                )
                            case 'network':
                                return (
                                    <ProfileNetwork subjectUser={user}/>
                                )
                            case 'groups':
                                return (
                                    <GroupSearch />
                                )
                            case 'events':
                                return (
                                    <EventSearch allowEventCreation={false} identifyGroups={true}/>
                                )
                            default:
                                return null;
                        }
                    })()
                }
            </div>
        </div>

    );


}

ProfilePage.propTypes = {
    setupNavigation: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired
}

function mapStateToProps(state) {
    return {
        user: state.user
    };
}

const mapDispatchToProps = {
    setupNavigation
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePage);

/*

<li class="nav-item">
                            <button name="timeline" class="btn-link nav-link active" onClick={setForm}>Timeline</button>
                        </li>
                        <li class="nav-item">
                            <button name="followers" class="btn-link nav-link" onClick={setForm}>Followers</button>
                        </li>
                        <li class="nav-item">
                            <button name="following" class="btn-link nav-link" onClick={setForm}>Following</button>
                        </li>



*/


// WEBPACK FOOTER //
// ./src/components/user/profile/ProfilePage.js